module.exports = __webpack_public_path__ + "static/media/muscleaider-2.4025ee1e.png";